import { z } from "zod";

/**
 * ObraArquivoSchema
 */

export const ObraArquivoSchema = z.object({
  statusArquivo: z.coerce.number().default(1),
  nomeDocumento: z.string().nonempty('Este campo deve ser preenchido!'),
  file: z.instanceof(File).nullable().default(null),
  dataVencimento: z.coerce.date().nullable().default(null),
});

/**
 * ObraArquivoForm
 */

export type ObraArquivoForm = z.infer<typeof ObraArquivoSchema>;

/**
 * initialObraArquivo
 */

export const initialObraArquivo: Partial<ObraArquivoForm> = {
  statusArquivo: 1,
  dataVencimento: null,
};